import qs from 'qs';
import { encryption } from '@/util/util'
import axios from '@/util/request'

export function login(userInfo) {
  // 检查是否为单点登录
  if ( userInfo.origin && userInfo.code) {
    // 单点登录逻辑
    const grant_type = 'sso_code';
    return axios({
      url: '/ims/sso/login',
      headers: {
        isToken: false,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic dGVzdDp0ZXN0'
      },
      method: 'post',
      params: { grant_type },
      data: qs.stringify({ origin: userInfo.origin, code: userInfo.code })
    });
  } else {
    // 普通登录逻辑
    const user = encryption({
      data: userInfo,
      key: 'pigxpigxpigxpigx',
      param: ['password']
    })
    const { username, password } = user
    const grant_type = 'password'
    return axios({
      url: '/auth/oauth/token',
      headers: {
        isToken: false,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic dGVzdDp0ZXN0'
      },
      method: 'post',
      params: { grant_type },
      data: qs.stringify({ username, password })
    })
  }
}

export const getUserInfo = () => {
  return axios({
    url: '/admin/user/info',
    method: 'get'
  })
}

export const logout = () => {
  return axios({
    url: '/auth/token/logout',
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/loginApi.js